import { FC, useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Button, Divider, Typography } from '@mui/material';
import { ROUTES } from 'routes';
import { useAppDispatch } from 'store/hooks';
import { changeModalOpen } from 'store/system';
import { CREATE_ROUTES } from 'utils/constants';
import { PLATFORM_TABS } from 'utils/constants/tabs';
import SearchBar from '../SearchBar';
import UserProfile from '../UserProfile';
import s from './styles.module.scss';
import { generateNestedRoute } from 'utils/helpers';

const Header: FC = () => {
	const dispatch = useAppDispatch();
	const { pathname, key } = useLocation();

	const navigate = useNavigate();

	const pageTitle = useMemo(() => PLATFORM_TABS.find((el) => `/${el.path}` === pathname)?.title, [pathname]);

	const segments = pathname.split('/').filter(Boolean);

	const handlerGoBack = () => {
		if (key === 'default') {
			navigate(generateNestedRoute(...segments.slice(0, -1)), { replace: true });
			return;
		}
		navigate(-1);
	};

	const handleOpenCreateModal = () => {
		dispatch(changeModalOpen());
	};

	return (
		<div className={s.wrapper}>
			<div className={s.container}>
				{pathname !== `/${ROUTES.profileSetups}` ? (
					segments.length > 1 ? (
						<Button className={s['back-button']} variant="text" color="primary" onClick={handlerGoBack}>{`< Назад`}</Button>
					) : (
						<>
							<Typography variant="h4">{pageTitle}</Typography>
							{!(pathname === `/${ROUTES.reportData}` || pathname === `/${ROUTES.dataSettings}`) && <SearchBar />}
							{CREATE_ROUTES.includes(pathname) && (
								<>
									<Divider orientation="vertical" flexItem />
									<Button variant="outlined" onClick={handleOpenCreateModal}>
										+ Додати
									</Button>
								</>
							)}
						</>
					)
				) : (
					<Typography variant="h4">Мій профіль</Typography>
				)}
			</div>
			<UserProfile />
		</div>
	);
};

export default Header;
